
import { useState, useEffect } from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { MapPin, Search } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

interface LocationSuggestion {
  id: string;
  name: string;
  address: string;
  city: string;
  region: string;
}

interface LocationSearchProps {
  onLocationSelect: (location: { address: string; city: string }) => void;
  placeholder?: string;
  value?: string;
}

// COMPREHENSIVE Gambian locations database - ALL major locations in The Gambia
const gambianLocations: LocationSuggestion[] = [
  // BANJUL REGION
  { id: '1', name: 'Banjul', address: 'Banjul City Center', city: 'Banjul', region: 'Banjul' },
  { id: '2', name: 'Banjul Central', address: 'Independence Drive', city: 'Banjul', region: 'Banjul' },
  { id: '3', name: 'Banjul Port', address: 'Banjul Port Area', city: 'Banjul', region: 'Banjul' },
  { id: '4', name: 'Albert Market', address: 'Albert Market', city: 'Banjul', region: 'Banjul' },
  { id: '5', name: 'Box Bar', address: 'Box Bar Road', city: 'Banjul', region: 'Banjul' },
  { id: '6', name: 'Soldier Town', address: 'Soldier Town', city: 'Banjul', region: 'Banjul' },
  { id: '7', name: 'Cape Point', address: 'Cape Point', city: 'Banjul', region: 'Banjul' },
  { id: '8', name: 'Old Town', address: 'Old Town Banjul', city: 'Banjul', region: 'Banjul' },
  { id: '9', name: 'Marina Parade', address: 'Marina Parade', city: 'Banjul', region: 'Banjul' },
  { id: '10', name: 'King Fahad Mosque', address: 'King Fahad Mosque Area', city: 'Banjul', region: 'Banjul' },

  // WESTERN REGION - GREATER BANJUL AREA
  { id: '11', name: 'Bakau', address: 'Bakau New Town', city: 'Bakau', region: 'Western' },
  { id: '12', name: 'Bakau Old Town', address: 'Bakau Old Town', city: 'Bakau', region: 'Western' },
  { id: '13', name: 'Cape Point Bakau', address: 'Cape Point Bakau', city: 'Bakau', region: 'Western' },
  { id: '14', name: 'Fajara', address: 'Fajara Golf Course Area', city: 'Fajara', region: 'Western' },
  { id: '15', name: 'Fajara Atlantic Hotel', address: 'Atlantic Hotel Area', city: 'Fajara', region: 'Western' },
  { id: '16', name: 'Kairaba', address: 'Kairaba Avenue', city: 'Kairaba', region: 'Western' },
  { id: '17', name: 'Pipeline', address: 'Pipeline Area', city: 'Pipeline', region: 'Western' },
  { id: '18', name: 'Kololi', address: 'Kololi Beach Resort Area', city: 'Kololi', region: 'Western' },
  { id: '19', name: 'Bijilo', address: 'Bijilo Forest Park Area', city: 'Bijilo', region: 'Western' },
  { id: '20', name: 'Brufut', address: 'Brufut Heights', city: 'Brufut', region: 'Western' },
  { id: '21', name: 'Brufut Beach', address: 'Brufut Beach', city: 'Brufut', region: 'Western' },
  { id: '22', name: 'Sukuta', address: 'Sukuta Traffic Light', city: 'Sukuta', region: 'Western' },
  { id: '23', name: 'Brusubi', address: 'Brusubi Phase 1', city: 'Brusubi', region: 'Western' },
  { id: '24', name: 'Brusubi Phase 2', address: 'Brusubi Phase 2', city: 'Brusubi Phase 2', region: 'Western' },
  { id: '25', name: 'Brusubi Phase 3', address: 'Brusubi Phase 3', city: 'Brusubi Phase 3', region: 'Western' },
  { id: '26', name: 'Brusubi Phase 4', address: 'Brusubi Phase 4', city: 'Brusubi Phase 4', region: 'Western' },

  // KANIFING MUNICIPALITY
  { id: '27', name: 'Serrekunda', address: 'Serrekunda Market Area', city: 'Serrekunda', region: 'Western' },
  { id: '28', name: 'Serrekunda Central', address: 'Serrekunda Central Market', city: 'Serrekunda', region: 'Western' },
  { id: '29', name: 'Westfield', address: 'Westfield Junction', city: 'Westfield', region: 'Western' },
  { id: '30', name: 'London Corner', address: 'London Corner', city: 'Serrekunda', region: 'Western' },
  { id: '31', name: 'Latrikunda', address: 'Latrikunda Sabiji', city: 'Latrikunda', region: 'Western' },
  { id: '32', name: 'Latrikunda German', address: 'Latrikunda German', city: 'Latrikunda German', region: 'Western' },
  { id: '33', name: 'Latrikunda Yiringanya', address: 'Latrikunda Yiringanya', city: 'Latrikunda Yiringanya', region: 'Western' },
  { id: '34', name: 'Tallinding', address: 'Tallinding Kunjang', city: 'Tallinding', region: 'Western' },
  { id: '35', name: 'Dippa Kunda', address: 'Dippa Kunda', city: 'Dippa Kunda', region: 'Western' },
  { id: '36', name: 'New Jeshwang', address: 'New Jeshwang', city: 'New Jeshwang', region: 'Western' },
  { id: '37', name: 'Old Jeshwang', address: 'Old Jeshwang', city: 'Old Jeshwang', region: 'Western' },
  { id: '38', name: 'Kanifing', address: 'Kanifing Municipality', city: 'Kanifing', region: 'Western' },
  { id: '39', name: 'Bundung', address: 'Bundung', city: 'Bundung', region: 'Western' },
  { id: '40', name: 'Manjai', address: 'Manjai Kunda', city: 'Manjai', region: 'Western' },
  { id: '41', name: 'Bartez', address: 'Bartez', city: 'Bartez', region: 'Western' },
  { id: '42', name: 'Tabokoto', address: 'Tabokoto', city: 'Tabokoto', region: 'Western' },
  { id: '43', name: 'Sinchu Alagie', address: 'Sinchu Alagie', city: 'Sinchu Alagie', region: 'Western' },
  { id: '44', name: 'Abuko', address: 'Abuko Nature Reserve', city: 'Abuko', region: 'Western' },
  { id: '45', name: 'Lamin', address: 'Lamin Village', city: 'Lamin', region: 'Western' },
  { id: '46', name: 'Yundum', address: 'Yundum Barracks', city: 'Yundum', region: 'Western' },
  { id: '47', name: 'Yundum Airport', address: 'Banjul International Airport', city: 'Yundum', region: 'Western' },
  { id: '48', name: 'Churchills Town', address: 'Churchills Town', city: 'Churchills Town', region: 'Western' },
  { id: '49', name: 'Ebo Town', address: 'Ebo Town', city: 'Ebo Town', region: 'Western' },

  // KOMBO CENTRAL & SOUTH
  { id: '50', name: 'Brikama', address: 'Brikama Ba', city: 'Brikama', region: 'Western' },
  { id: '51', name: 'Brikama Nding', address: 'Brikama Nding', city: 'Brikama Nding', region: 'Western' },
  { id: '52', name: 'Brikama Kabafita', address: 'Brikama Kabafita', city: 'Brikama Kabafita', region: 'Western' },
  { id: '53', name: 'Sanchaba', address: 'Sanchaba Sulay Jobe', city: 'Sanchaba', region: 'Western' },
  { id: '54', name: 'Gunjur', address: 'Gunjur Village', city: 'Gunjur', region: 'Western' },
  { id: '55', name: 'Sanyang', address: 'Sanyang Beach', city: 'Sanyang', region: 'Western' },
  { id: '56', name: 'Tanji', address: 'Tanji Fishing Village', city: 'Tanji', region: 'Western' },
  { id: '57', name: 'Kartong', address: 'Kartong Beach', city: 'Kartong', region: 'Western' },
  { id: '58', name: 'Tujereng', address: 'Tujereng Village', city: 'Tujereng', region: 'Western' },
  { id: '59', name: 'Berending', address: 'Berending', city: 'Berending', region: 'Western' },
  { id: '60', name: 'Manduar', address: 'Manduar Village', city: 'Manduar', region: 'Western' },
  { id: '61', name: 'Kafuta', address: 'Kafuta Village', city: 'Kafuta', region: 'Western' },
  { id: '62', name: 'Gunjur Kuta', address: 'Gunjur Kuta', city: 'Gunjur Kuta', region: 'Western' },
  { id: '63', name: 'Batokunku', address: 'Batokunku', city: 'Batokunku', region: 'Western' },
  { id: '64', name: 'Bonto', address: 'Bonto Village', city: 'Bonto', region: 'Western' },
  { id: '65', name: 'Tujering', address: 'Tujering Village', city: 'Tujering', region: 'Western' },
  { id: '66', name: 'Ghana Town', address: 'Ghana Town', city: 'Ghana Town', region: 'Western' },
  { id: '67', name: 'Sintet', address: 'Sintet Village', city: 'Sintet', region: 'Western' },
  { id: '68', name: 'Pirang', address: 'Pirang Village', city: 'Pirang', region: 'Western' },

  // KOMBO NORTH
  { id: '69', name: 'Essau', address: 'Essau Town', city: 'Essau', region: 'North Bank' },
  { id: '70', name: 'Kanuma', address: 'Kanuma Village', city: 'Kanuma', region: 'Western' },
  { id: '71', name: 'Busumbala', address: 'Busumbala', city: 'Busumbala', region: 'Western' },
  { id: '72', name: 'Jimara', address: 'Jimara Village', city: 'Jimara', region: 'Western' },
  { id: '73', name: 'Faraba Banta', address: 'Faraba Banta', city: 'Faraba Banta', region: 'Western' },
  { id: '74', name: 'Darsilami', address: 'Darsilami Village', city: 'Darsilami', region: 'Western' },
  { id: '75', name: 'Wellingara', address: 'Wellingara Village', city: 'Wellingara', region: 'Western' },
  { id: '76', name: 'Kitty', address: 'Kitty Village', city: 'Kitty', region: 'Western' },
  { id: '77', name: 'Sukuta Jabang', address: 'Sukuta Jabang', city: 'Sukuta Jabang', region: 'Western' },
  { id: '78', name: 'Jabang', address: 'Jabang Village', city: 'Jabang', region: 'Western' },

  // NORTH BANK REGION
  { id: '79', name: 'Barra', address: 'Barra Ferry Terminal', city: 'Barra', region: 'North Bank' },
  { id: '80', name: 'Albreda', address: 'Albreda Historical Site', city: 'Albreda', region: 'North Bank' },
  { id: '81', name: 'Jufureh', address: 'Jufureh Kunta Kinteh Island', city: 'Jufureh', region: 'North Bank' },
  { id: '82', name: 'Farafenni', address: 'Farafenni Market', city: 'Farafenni', region: 'North Bank' },
  { id: '83', name: 'Kerewan', address: 'Kerewan Town', city: 'Kerewan', region: 'North Bank' },
  { id: '84', name: 'Amdalai', address: 'Amdalai Village', city: 'Amdalai', region: 'North Bank' },
  { id: '85', name: 'Njaba Kunda', address: 'Njaba Kunda', city: 'Njaba Kunda', region: 'North Bank' },
  { id: '86', name: 'Lamin Koto', address: 'Lamin Koto', city: 'Lamin Koto', region: 'North Bank' },
  { id: '87', name: 'Salikene', address: 'Salikene Village', city: 'Salikene', region: 'North Bank' },
  { id: '88', name: 'Buniadu', address: 'Buniadu', city: 'Buniadu', region: 'North Bank' },
  { id: '89', name: 'Illiassa', address: 'Illiassa Village', city: 'Illiassa', region: 'North Bank' },
  { id: '90', name: 'Chilla', address: 'Chilla Village', city: 'Chilla', region: 'North Bank' },
  { id: '91', name: 'Berending NBR', address: 'Berending North Bank', city: 'Berending', region: 'North Bank' },
  { id: '92', name: 'Katchang', address: 'Katchang Village', city: 'Katchang', region: 'North Bank' },
  { id: '93', name: 'Lower Baddibu', address: 'Lower Baddibu District', city: 'Lower Baddibu', region: 'North Bank' },
  { id: '94', name: 'Upper Baddibu', address: 'Upper Baddibu District', city: 'Upper Baddibu', region: 'North Bank' },
  { id: '95', name: 'Keur Madiabel', address: 'Keur Madiabel', city: 'Keur Madiabel', region: 'North Bank' },
  { id: '96', name: 'No Kunda', address: 'No Kunda Village', city: 'No Kunda', region: 'North Bank' },
  { id: '97', name: 'Massar', address: 'Massar Village', city: 'Massar', region: 'North Bank' },
  { id: '98', name: 'Medina Salaam', address: 'Medina Salaam', city: 'Medina Salaam', region: 'North Bank' },

  // LOWER RIVER REGION
  { id: '99', name: 'Soma', address: 'Soma Town', city: 'Soma', region: 'Lower River' },
  { id: '100', name: 'Kaur', address: 'Kaur Town', city: 'Kaur', region: 'Lower River' },
  { id: '101', name: 'Kwinella', address: 'Kwinella Village', city: 'Kwinella', region: 'Lower River' },
  { id: '102', name: 'Mansa Konko', address: 'Mansa Konko', city: 'Mansa Konko', region: 'Lower River' },
  { id: '103', name: 'Kaiaf', address: 'Kaiaf Village', city: 'Kaiaf', region: 'Lower River' },
  { id: '104', name: 'Niamina Dankunku', address: 'Niamina Dankunku', city: 'Niamina Dankunku', region: 'Lower River' },
  { id: '105', name: 'Kiang Central', address: 'Kiang Central', city: 'Kiang Central', region: 'Lower River' },
  { id: '106', name: 'Kiang East', address: 'Kiang East', city: 'Kiang East', region: 'Lower River' },
  { id: '107', name: 'Kiang West', address: 'Kiang West', city: 'Kiang West', region: 'Lower River' },
  { id: '108', name: 'Jarra Central', address: 'Jarra Central', city: 'Jarra Central', region: 'Lower River' },
  { id: '109', name: 'Jarra East', address: 'Jarra East', city: 'Jarra East', region: 'Lower River' },
  { id: '110', name: 'Jarra West', address: 'Jarra West', city: 'Jarra West', region: 'Lower River' },
  { id: '111', name: 'Janjanbureh', address: 'Janjanbureh (Georgetown)', city: 'Georgetown', region: 'Lower River' },
  { id: '112', name: 'Wassu', address: 'Wassu Stone Circles', city: 'Wassu', region: 'Lower River' },
  { id: '113', name: 'Sankandi', address: 'Sankandi Village', city: 'Sankandi', region: 'Lower River' },
  { id: '114', name: 'Dumbutu', address: 'Dumbutu Village', city: 'Dumbutu', region: 'Lower River' },
  { id: '115', name: 'Pakalinding', address: 'Pakalinding Village', city: 'Pakalinding', region: 'Lower River' },
  { id: '116', name: 'Tendaba', address: 'Tendaba Camp', city: 'Tendaba', region: 'Lower River' },

  // CENTRAL RIVER REGION
  { id: '117', name: 'Georgetown', address: 'Georgetown (Janjanbureh)', city: 'Georgetown', region: 'Central River' },
  { id: '118', name: 'Kuntaur', address: 'Kuntaur Town', city: 'Kuntaur', region: 'Central River' },
  { id: '119', name: 'Bansang', address: 'Bansang Hospital Area', city: 'Bansang', region: 'Central River' },
  { id: '120', name: 'Kudang', address: 'Kudang Village', city: 'Kudang', region: 'Central River' },
  { id: '121', name: 'Baja Kunda', address: 'Baja Kunda', city: 'Baja Kunda', region: 'Central River' },
  { id: '122', name: 'Niani', address: 'Niani District', city: 'Niani', region: 'Central River' },
  { id: '123', name: 'Sami', address: 'Sami District', city: 'Sami', region: 'Central River' },
  { id: '124', name: 'Fulladu East', address: 'Fulladu East', city: 'Fulladu East', region: 'Central River' },
  { id: '125', name: 'Fulladu West', address: 'Fulladu West', city: 'Fulladu West', region: 'Central River' },
  { id: '126', name: 'Niamina East', address: 'Niamina East', city: 'Niamina East', region: 'Central River' },
  { id: '127', name: 'Niamina West', address: 'Niamina West', city: 'Niamina West', region: 'Central River' },
  { id: '128', name: 'Lower Saloum', address: 'Lower Saloum', city: 'Lower Saloum', region: 'Central River' },
  { id: '129', name: 'Upper Saloum', address: 'Upper Saloum', city: 'Upper Saloum', region: 'Central River' },
  { id: '130', name: 'Karantaba', address: 'Karantaba Village', city: 'Karantaba', region: 'Central River' },
  { id: '131', name: 'Panchang', address: 'Panchang Village', city: 'Panchang', region: 'Central River' },

  // UPPER RIVER REGION
  { id: '132', name: 'Basse', address: 'Basse Santa Su', city: 'Basse', region: 'Upper River' },
  { id: '133', name: 'Fatoto', address: 'Fatoto Border', city: 'Fatoto', region: 'Upper River' },
  { id: '134', name: 'Gambisara', address: 'Gambisara Village', city: 'Gambisara', region: 'Upper River' },
  { id: '135', name: 'Koina', address: 'Koina Village', city: 'Koina', region: 'Upper River' },
  { id: '136', name: 'Diabugu', address: 'Diabugu Village', city: 'Diabugu', region: 'Upper River' },
  { id: '137', name: 'Sudowol', address: 'Sudowol Village', city: 'Sudowol', region: 'Upper River' },
  { id: '138', name: 'Wuli', address: 'Wuli District', city: 'Wuli', region: 'Upper River' },
  { id: '139', name: 'Kantora', address: 'Kantora District', city: 'Kantora', region: 'Upper River' },
  { id: '140', name: 'Tumana', address: 'Tumana Village', city: 'Tumana', region: 'Upper River' },
  { id: '141', name: 'Sandu', address: 'Sandu District', city: 'Sandu', region: 'Upper River' },
  { id: '142', name: 'Garawol', address: 'Garawol Village', city: 'Garawol', region: 'Upper River' },
  { id: '143', name: 'Sabi', address: 'Sabi Village', city: 'Sabi', region: 'Upper River' },

  // ADDITIONAL WESTERN DIVISION LOCATIONS
  { id: '144', name: 'Old Yundum', address: 'Old Yundum', city: 'Old Yundum', region: 'Western' },
  { id: '145', name: 'New Yundum', address: 'New Yundum', city: 'New Yundum', region: 'Western' },
  { id: '146', name: 'Bambali', address: 'Bambali Village', city: 'Bambali', region: 'Western' },
  { id: '147', name: 'Mandinaba', address: 'Mandinaba Village', city: 'Mandinaba', region: 'Western' },
  { id: '148', name: 'Madina Salaam West', address: 'Madina Salaam', city: 'Madina Salaam', region: 'Western' },
  { id: '149', name: 'Mandinary', address: 'Mandinary Village', city: 'Mandinary', region: 'Western' },
  { id: '150', name: 'Nyofelleh', address: 'Nyofelleh Village', city: 'Nyofelleh', region: 'Western' },

  // TOURIST/RESORT AREAS & MAJOR LANDMARKS
  { id: '151', name: 'Kotu', address: 'Kotu Beach Resort Area', city: 'Kotu', region: 'Western' },
  { id: '152', name: 'Kotu Beach', address: 'Kotu Beach Hotels', city: 'Kotu', region: 'Western' },
  { id: '153', name: 'Senegambia Strip', address: 'Senegambia Tourist Area', city: 'Kololi', region: 'Western' },
  { id: '154', name: 'Palma Rima', address: 'Palma Rima Beach Hotel', city: 'Kololi', region: 'Western' },
  { id: '155', name: 'Paradise Beach', address: 'Paradise Beach', city: 'Paradise Beach', region: 'Western' },

  // ADDITIONAL MAJOR AREAS AND SETTLEMENTS
  { id: '156', name: 'Brikama Ndemban', address: 'Brikama Ndemban', city: 'Brikama Ndemban', region: 'Western' },
  { id: '157', name: 'Brikama Jamisa', address: 'Brikama Jamisa', city: 'Brikama Jamisa', region: 'Western' },
  { id: '158', name: 'Gunjur Sukuta', address: 'Gunjur Sukuta', city: 'Gunjur Sukuta', region: 'Western' },
  { id: '159', name: 'Lamin Daranka', address: 'Lamin Daranka', city: 'Lamin Daranka', region: 'Western' },
  { id: '160', name: 'Bakoteh', address: 'Bakoteh', city: 'Bakoteh', region: 'Western' },
  { id: '161', name: 'Mile 7', address: 'Mile 7', city: 'Mile 7', region: 'Western' },
  { id: '162', name: 'Banjulinding', address: 'Banjulinding', city: 'Banjulinding', region: 'Western' },
  { id: '163', name: 'Mayamba', address: 'Mayamba', city: 'Mayamba', region: 'Western' },
  { id: '164', name: 'Tujereng Kunkujang', address: 'Tujereng Kunkujang', city: 'Tujereng Kunkujang', region: 'Western' },
  { id: '165', name: 'Gunjur Kanyanka', address: 'Gunjur Kanyanka', city: 'Gunjur Kanyanka', region: 'Western' },

  // MAJOR MARKETS AND COMMERCIAL AREAS
  { id: '166', name: 'Serrekunda Market', address: 'Serrekunda Central Market', city: 'Serrekunda', region: 'Western' },
  { id: '167', name: 'Brikama Market', address: 'Brikama Main Market', city: 'Brikama', region: 'Western' },
  { id: '168', name: 'Farafenni Market', address: 'Farafenni Central Market', city: 'Farafenni', region: 'North Bank' },
  { id: '169', name: 'Basse Market', address: 'Basse Central Market', city: 'Basse', region: 'Upper River' },
  { id: '170', name: 'Soma Market', address: 'Soma Central Market', city: 'Soma', region: 'Lower River' },

  // EDUCATIONAL AND HOSPITAL AREAS
  { id: '171', name: 'UTG Faraba Banta', address: 'University of The Gambia', city: 'Faraba Banta', region: 'Western' },
  { id: '172', name: 'RVTH', address: 'Royal Victoria Teaching Hospital', city: 'Banjul', region: 'Banjul' },
  { id: '173', name: 'Kanifing General Hospital', address: 'Kanifing General Hospital', city: 'Kanifing', region: 'Western' },
  { id: '174', name: 'Bansang Hospital', address: 'Bansang General Hospital', city: 'Bansang', region: 'Central River' },

  // ADDITIONAL VILLAGES AND TOWNS
  { id: '175', name: 'Sutukoba', address: 'Sutukoba Village', city: 'Sutukoba', region: 'Western' },
  { id: '176', name: 'Jambanjelly', address: 'Jambanjelly', city: 'Jambanjelly', region: 'Western' },
  { id: '177', name: 'Fass Njaga Choi', address: 'Fass Njaga Choi', city: 'Fass Njaga Choi', region: 'Western' },
  { id: '178', name: 'Jambur', address: 'Jambur Village', city: 'Jambur', region: 'Western' },
  { id: '179', name: 'Bureng', address: 'Bureng Village', city: 'Bureng', region: 'Western' },
  { id: '180', name: 'Kembujeh', address: 'Kembujeh Village', city: 'Kembujeh', region: 'Western' },
  { id: '181', name: 'Gunjur Manjago', address: 'Gunjur Manjago', city: 'Gunjur Manjago', region: 'Western' },
  { id: '182', name: 'Kafenda', address: 'Kafenda Village', city: 'Kafenda', region: 'Western' },
  { id: '183', name: 'Sibanor', address: 'Sibanor Village', city: 'Sibanor', region: 'Western' },
  { id: '184', name: 'Kabafita', address: 'Kabafita Village', city: 'Kabafita', region: 'Western' },
  { id: '185', name: 'Banjul International Airport', address: 'Banjul International Airport Terminal', city: 'Yundum', region: 'Western' },

  // FISHING VILLAGES AND COASTAL AREAS
  { id: '186', name: 'Tanji Fishing Center', address: 'Tanji Fish Market', city: 'Tanji', region: 'Western' },
  { id: '187', name: 'Gunjur Beach', address: 'Gunjur Beach', city: 'Gunjur', region: 'Western' },
  { id: '188', name: 'Sanyang Beach', address: 'Sanyang Paradise Beach', city: 'Sanyang', region: 'Western' },
  { id: '189', name: 'Kartong Beach', address: 'Kartong Folonko Beach', city: 'Kartong', region: 'Western' },
  { id: '190', name: 'Brufut Beach Club', address: 'Brufut Beach Club Area', city: 'Brufut', region: 'Western' },

  // RESIDENTIAL ESTATES AND NEW DEVELOPMENTS
  { id: '191', name: 'Bijilo Hills', address: 'Bijilo Hills Estate', city: 'Bijilo', region: 'Western' },
  { id: '192', name: 'Kairaba Estate', address: 'Kairaba Estate', city: 'Kairaba', region: 'Western' },
  { id: '193', name: 'Fajara Club', address: 'Fajara Club Area', city: 'Fajara', region: 'Western' },
  { id: '194', name: 'Cape Point Estate', address: 'Cape Point Estate', city: 'Bakau', region: 'Western' },
  { id: '195', name: 'Brufut Gardens', address: 'Brufut Gardens', city: 'Brufut', region: 'Western' },

  // INDUSTRIAL AND COMMERCIAL ZONES
  { id: '196', name: 'Kanifing Industrial Area', address: 'Kanifing Industrial Estate', city: 'Kanifing', region: 'Western' },
  { id: '197', name: 'Banjul Port Industrial', address: 'Banjul Port Industrial Zone', city: 'Banjul', region: 'Banjul' },
  { id: '198', name: 'Serrekunda Commercial', address: 'Serrekunda Commercial District', city: 'Serrekunda', region: 'Western' },

  // BORDER TOWNS AND CROSSINGS
  { id: '199', name: 'Amdalai Border', address: 'Amdalai Border Crossing', city: 'Amdalai', region: 'North Bank' },
  { id: '200', name: 'Fatoto Border', address: 'Fatoto Border Post', city: 'Fatoto', region: 'Upper River' },
];

const LocationSearch = ({ onLocationSelect, placeholder = "Search for locations in Gambia...", value = '' }: LocationSearchProps) => {
  const [query, setQuery] = useState(value);
  const [suggestions, setSuggestions] = useState<LocationSuggestion[]>([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  useEffect(() => {
    setQuery(value);
  }, [value]);

  useEffect(() => {
    if (query.length > 0) {
      const filtered = gambianLocations.filter(location =>
        location.name.toLowerCase().includes(query.toLowerCase()) ||
        location.address.toLowerCase().includes(query.toLowerCase()) ||
        location.city.toLowerCase().includes(query.toLowerCase()) ||
        location.region.toLowerCase().includes(query.toLowerCase())
      );
      setSuggestions(filtered);
      setShowSuggestions(true);
    } else {
      // Show popular locations when no query
      setSuggestions(gambianLocations.slice(0, 20)); // Show first 20 by default
      setShowSuggestions(false);
    }
  }, [query]);

  const handleSuggestionClick = (suggestion: LocationSuggestion) => {
    setQuery(suggestion.address);
    setShowSuggestions(false);
    onLocationSelect({
      address: suggestion.address,
      city: suggestion.city
    });
  };

  const handleFocus = () => {
    if (query.length === 0) {
      setSuggestions(gambianLocations.slice(0, 20));
      setShowSuggestions(true);
    } else {
      setShowSuggestions(true);
    }
  };

  const handleBlur = () => {
    // Delay hiding suggestions to allow for click
    setTimeout(() => setShowSuggestions(false), 150);
  };

  return (
    <div className="relative">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
        <Input
          placeholder={placeholder}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onFocus={handleFocus}
          onBlur={handleBlur}
          className="pl-10"
        />
      </div>
      
      {showSuggestions && suggestions.length > 0 && (
        <Card className="absolute top-full left-0 right-0 z-50 mt-1 max-h-60 overflow-y-auto">
          <CardContent className="p-0">
            {suggestions.map((suggestion) => (
              <Button
                key={suggestion.id}
                variant="ghost"
                className="w-full justify-start h-auto p-3 border-b border-gray-100 last:border-b-0"
                onMouseDown={(e) => e.preventDefault()} // Prevent blur from firing before click
                onClick={() => handleSuggestionClick(suggestion)}
              >
                <div className="flex items-center gap-3 w-full">
                  <MapPin className="h-4 w-4 text-gray-400" />
                  <div className="flex-1 text-left">
                    <p className="font-medium">{suggestion.name}</p>
                    <p className="text-sm text-gray-600">{suggestion.address}</p>
                    <p className="text-xs text-gray-500">{suggestion.region} Region</p>
                  </div>
                </div>
              </Button>
            ))}
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default LocationSearch;
